<template>
  <Transition name="slide-fade">
    <div
      v-if="isShow"
      class="progress-bar"
      v-tooltip="tooltipOptions"
    >
      <div
        v-for="(step, index) in comboCompany.progress.totalStep"
        :key="step"
        class="progress-step"
      >
        <div
          class="progress-circle"
          :class="{
            active: step <= currentStep,
          }"
          :style="{ '--active-color': comboCompany.product_teg_bg }"
        >

          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="none"
            class="icon"
          >
            <template v-if="index === lastIndex">
              <path d="M5.19998 26.8C5.19998 27.52 5.67996 27.9999 6.39996 27.9999H14.8V17.1999H5.19998V26.8Z" />
              <path d="M17.2 28H25.6C26.32 28 26.8 27.52 26.8 26.8V17.2H17.2V28Z" />
              <path d="M4 11.2V13.6C4 14.32 4.47998 14.8 5.19998 14.8H14.8V9.99997H5.19998C4.47998 9.99997 4 10.48 4 11.2Z" />
              <path d="M26.8 9.99997H17.2V14.8H26.8C27.52 14.8 28 14.32 28 13.6V11.2C28 10.48 27.52 9.99997 26.8 9.99997Z" />
              <path d="M10.72 8.79993L10.36 8.43993C9.88003 7.95995 9.88003 7.23995 10.36 6.75991C10.6 6.51989 10.96 6.39991 11.2 6.39991C11.56 6.39991 11.8 6.51989 12.04 6.75991L14.08 8.79993H17.8L19.84 6.75997C20.32 6.27998 21.04 6.27998 21.52 6.75997C22 7.23995 22 7.95995 21.52 8.43999L21.28 8.79999H24.16C24.64 7.47997 24.28 6.03997 23.32 5.08C21.88 3.64 19.6 3.64 18.28 5.08L16 7.24001L13.84 5.08C12.4 3.64 10.1201 3.64 8.68005 5.08C7.71998 6.03997 7.35998 7.47997 7.84002 8.79993H10.72Z" />
            </template>

            <path
              v-else
              d="M16 4C9.352 4 4 9.352 4 16s5.352 12 12 12 12-5.352 12-12S22.648 4 16 4zm5.447 7.008a1 1 0 0 1 .563.258 1 1 0 0 1 .054 1.412l-7.382 8a1 1 0 0 1-1.471 0L9.93 17.123a1 1 0 0 1 .056-1.414 1 1 0 0 1 1.412.057l2.547 2.76 6.65-7.204a1 1 0 0 1 .852-.314z"
            />
          </svg>
        </div>

        <div
          v-if="index < comboCompany.progress.totalStep - 1"
          class="progress-line"
          :class="{ active: step <= currentStep }"
          :style="{ '--active-color': comboCompany.product_teg_bg }"
        ></div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { useWindowScroll } from '@vueuse/core'

import { mapState } from 'vuex'
const SHOW_ON_PAGES = [
  'index',
  'catalog:category:page',
  'catalog:category:product:page',
  'product:detail',
  'order:create',
  'order:detail'
]

export default {
  name: "ComboProgress",

  data() {
    return {
      isMounted: false
    }
  },

  mounted() {
    this.isMounted = true
  },

  computed: {
    ...mapState({
      comboCompany: state => state.cart.comboCompany,
      isMobile: state => state.isMobile,
    }),

    currentStep() {
      return this.comboCompany.progress.currentStep
    },

    lastIndex() {
      return Object.keys(this.comboCompany.progress.step).length - 1;
    },

    tooltipOptions() {
      return {
        content: this.comboCompany.condition_text,
        triggers: this. isMobile ? ['click'] : ['hover'],
        disabled: this.isScrolling
      }
    },

    isShow() {
      return this.isMounted && this.comboCompany && SHOW_ON_PAGES.includes(this.$route.name)
    }
  },

  setup() {
    const { isScrolling } = useWindowScroll()

    return { isScrolling }
  }
}
</script>

<style lang="scss" scoped>
.progress-bar {
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  top: 55px;

  @media screen and (min-width: 1024px) {
    bottom: 20px;
    top: initial;
    transform: translateX(-50%);
  }
}

.progress-step {
  display: flex;
  align-items: center;
  position: relative;
}

.progress-line {
  width: 26px;
  height: 2px;
  background-color: #9c7345;
  transition: background 0.3s;

  &.active {
    background-color: var(--active-color);
  }

  @media screen and (min-width: 1024px) {
    height: 4px;
    width: 40px;
  }
}

.progress-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 2px solid #9c7345;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  transition: background 0.3s, border-color 0.3s;

  &.active {
    background: var(--active-color);
    border-color: var(--active-color);
    color: white;

    .icon {
      fill: #f7ebdf;
    }
  }

  @media screen and (min-width: 1024px) {
    width: 60px;
    height: 60px;
    border: 4px solid #9c7345;
  }
}

.icon {
  width: 18x;
  height: 18px;
  fill: #9c7345;
  transition: fill 0.3s;

  @media screen and (min-width: 1024px) {
    width: 32x;
    height: 32px;
  }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -100px);

  @media screen and (min-width: 1024px) {
    transform: translate(-50%, 100px);
  }
}
</style>
